// Platzierbare Blöcke („Orte“, „Weitere Inseln“) innerhalb der SEO-Textabschnitte von Insel-, Orts- und Regionsseiten.
// Blöcke stehen nur im deutschen sections-Array ({ block: "places", slugs?: [...] } | { block: "islands" }); die Position gilt für alle Sprachen.
export const BLOCK_KINDS = ["island", "place", "region"];
export const blockLabel = (kind, block) => block === "islands" ? "Weitere Inseln entdecken" : kind === "place" ? "Weitere Orte auf der Insel" : kind === "region" ? "Orte in der Region" : "Orte auf der Insel";
export const BLOCKS = ["places", "islands"];

export const isBlock = (s) => !!(s && s.block);
// Index unter den reinen Textabschnitten (Blöcke nicht mitgezählt)
export const textIndex = (arr, i) => (arr || []).slice(0, i).filter((s) => !isBlock(s)).length;
// Voller Index des ti-ten Textabschnitts
export const fullIndex = (arr, ti) => { let k = 0; for (let j = 0; j < (arr || []).length; j++) { if (!isBlock(arr[j])) { if (k === ti) return j; k++; } } return (arr || []).length; };
export const hasBlocks = (deSections) => (deSections || []).some(isBlock);
// Orte-Auswahl anwenden: slugs leer = alle; exclude = aktueller Ort
export const filterPlaces = (places, slugs, exclude) => (places || []).filter((p) => p.slug !== exclude && (!slugs?.length || slugs.includes(p.slug)));

// Blöcke aus der deutschen Reihenfolge in die Textabschnitte der Zielsprache einfügen
export const mergeBlocks = (sections, deSections) => {
  const texts = (sections || []).filter((s) => !isBlock(s));
  if (!hasBlocks(deSections)) return texts;
  const out = []; let k = 0;
  for (const s of deSections) {
    if (isBlock(s)) out.push(s);
    else if (k < texts.length) out.push(texts[k++]);
  }
  while (k < texts.length) out.push(texts[k++]);
  return out;
};
